export const APP_NAMESPACE = '1PO';
